<template>
  <div>
    <!-- 公告显示在图片中 -->
    <div style="position: relative">
      <Button
        class="inviteButton"
        round
        color="linear-gradient(to right, #ff6034, #ee0a24)"
        @click="openInviteWindow"
        >邀请好友赚钱</Button
      >
      <Popover
        v-model:show="data.showPopover"
        :actions="data.actions"
        placement="left-start"
        @select="onSelect"
      >
        <template #reference>
          <Button
            type="success"
            icon="orders-o"
            round
            style="font-size: 20px; padding: 10px"
          ></Button>
        </template>
      </Popover>

      <Swipe :autoplay="5000" :show-indicators="false" :touchable="false">
        <SwipeItem><img src="cover.jpeg" class="cover" /></SwipeItem>
        <SwipeItem @click="openInviteWindow"
          ><img src="cover_1.jpg" class="cover"
        /></SwipeItem>
      </Swipe>
      <div class="NoticeBarClass">
        <NoticeBar
          left-icon="volume-o"
          :scrollable="false"
          @click="data.show = true"
          mode="link"
        >
          <Swipe
            vertical
            class="notice-swipe"
            :autoplay="3000"
            :show-indicators="false"
          >
            <SwipeItem>网站流量大，请求速度慢，请君耐心等待～</SwipeItem>
            <SwipeItem
              >若提交出现一长串报错为网络问题，再次尝试即可～</SwipeItem
            >
            <SwipeItem>遇到其他问题，请点击我，加客服微信解决～</SwipeItem>
            <SwipeItem>网站不会保存密码数据，若担心请自行修改密码！</SwipeItem>
          </Swipe>
        </NoticeBar>
      </div>
    </div>
    <Popup
      :show="data.show"
      teleport="#app"
      @click-overlay="data.show = false"
      round
    >
      <WeChat title="长按二维码加好友" />
    </Popup>
    <div class="box">
      <h2>开始</h2>
      <div class="Step_help">
        <h4 :style="page1_Step1Color" style="margin: 0">
          ① 填入课群课群ID&nbsp;
        </h4>
        <!-- 步骤1提示 -->
        <Button type="warning" size="mini" @click="data.isShowHelp = true"
          >哪个是课群ID?</Button
        >
        <Step1Help
          :isShowHelp="data.isShowHelp"
          @update:isShowHelp="data.isShowHelp = $event"
        />
        <!-- 步骤1提示 -->
      </div>
      <CellGroup inset>
        <Field
          focus="true"
          v-model="sitedData.groupID"
          center
          clearable
          label="课群ID"
          placeholder="请输入易班课群ID"
          @keyup.enter="queryGroupInfoKeyup"
        >
          <template #button>
            <Button size="small" type="primary" @click="queryGroupInfo"
              >确认</Button
            >
          </template>
        </Field>
      </CellGroup>
      <!-- 课群信息弹窗 -->
      <VanDialog
        :show="data.isgroupInfoShow"
        title="课群基本信息"
        show-cancel-button
        confirm-button-text="确认无误"
        cancel-button-text="不是这个"
        :beforeClose="closeGroupInfo"
        style="text-align: center"
        teleport="#app"
      >
        <img :src="data.groupInfo.img" style="width: 100%" />
        <u class="groupTitle">{{ data.groupInfo.title }}</u>
      </VanDialog>

      <Divider />

      <!-- 步骤2 -->
      <div class="Step_help">
        <h4 :style="page1_Step2Color" style="margin: 0">
          ② 填写易班账号密码&nbsp;
        </h4>
        <Button type="warning" size="mini" @click="forgetPassword"
          >忘记密码咋办?</Button
        >
      </div>
      <Form @submit="login" @failed="onFailed">
        <CellGroup inset>
          <!-- 输入手机号，调起手机号键盘 -->
          <Field
            v-model="sitedData.user.tel"
            type="tel"
            label="手机号"
            placeholder="请输入易班手机号"
            :rules="[{ pattern, message: '请输入正确的手机号' }]"
          />
          <!-- 输入密码 -->
          <Field
            v-model="sitedData.user.password"
            type="password"
            label="密码"
            placeholder="请输入易班密码"
            :rules="[{ required: true, message: '请填写密码' }]"
          />
        </CellGroup>

        <div style="margin: 16px">
          <Button round block type="primary" native-type="submit" size="small">
            登录
          </Button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import Step1Help from "./page1_Step1_help.vue";
import WeChat from "@/components/WeChat.vue";
import { useData } from "@/composables/useData.js";
import {
  Field,
  CellGroup,
  Button,
  Divider,
  Dialog,
  Form,
  Toast,
  Notify,
  NoticeBar,
  Popup,
  Popover,
  Swipe,
  SwipeItem,
} from "vant";
import { useRouter } from "vue-router";
import { userService } from "@/service/userService";
import { groupService } from "@/service/groupService";
const router = useRouter();
// 弹出框
const VanDialog = Dialog.Component;
// 校验手机号
const pattern = /^1[3456789]\d{9}$/;
const data = ref({
  groupInfo: {
    // 课群信息
    title: "",
    img: "",
  },
  isgroupInfoShow: false, // 是否显示课群信息
  isShowHelp: false, // 是否显示帮助信息
  show: false, // 是否显示二维码

  showPopover: false, // 显示气泡弹出框
  actions: [{ text: "教学视频" }, { text: "查找订单" }], // 气泡弹出框选项
  videoSrc: "vedio.mp4",
  videoState: false,
});

// 引入共享数据
const { sitedData } = useData();

//  查询课群信息点击事件
const queryGroupInfo = () => {
  const toast = Toast.loading({
    message: "查询中...",
    duration: 0,
    forbidClick: true,
  });
  // 查询课群请求
  groupService
    .getGroupInfo(sitedData.value.groupID)
    .then((resData) => {
      toast.clear();
      if (resData.state == "error") {
        sitedData.value.page1_Step1 = 2;
        Notify({
          type: "danger",
          message: resData.result,
        });
        return;
      }
      data.value.isgroupInfoShow = true;
      data.value.groupInfo.title = resData.result.title;
      data.value.groupInfo.img = resData.result.img;
    })
    .catch((err) => {
      toast.clear();
      sitedData.value.page1_Step1 = 2;
      Notify({
        type: "danger",
        message: err.result == "" ? "网络通信问题，请再试一次" : err.result,
      });
    });
};
const onSelect = (action) => {
  if (action.text == "查找订单") {
    // 跳转至订单页面
    router.push("/order");
  } else if (action.text == "教学视频") {
    // 跳转至视频页面
    location.href = "vedio.mp4";
  } else if (action.text == "邀请查询") {
    router.push("/invite");
  }
};
const openInviteWindow = () => {
  router.push("/invite");
};
// 查询登录信息点击事件
const login = () => {
  // console.log("login事件");
  const toast = Toast.loading({
    message: "加载中...",
    forbidClick: true,
    duration: 0,
  });
  // 登录账户请求
  userService
    .login(sitedData.value.user.tel, sitedData.value.user.password)
    .then((resData) => {
      toast.clear();
      let message = "";
      if (resData.state != "success") {
        sitedData.value.page1_Step2 = 2;
        message = resData.result;
      } else {
        // 登录成功
        sitedData.value.page1_Step2 = 1;
        message = resData.result.UserInfo;
        // 存储用户信息
        sitedData.value.user.sessionID = resData.result.Sessionid;
        sitedData.value.user.userID = resData.result.UserId;
        sitedData.value.user.yibanID = resData.result.YibanId;
        sitedData.value.user.userToken = resData.result.UserToken;
        sitedData.value.user.userInfo = message;
      }
      Dialog.alert({
        title: "查询账户返回信息",
        message,
      });
    })
    .catch((err) => {
      toast.clear();
      Dialog.alert({
        title: "查询账户返回信息",
        message: err == "" ? "网络通信问题，请再试一次" : err,
      });
    });
};

// 关闭课群确定窗口事件
const closeGroupInfo = (action) => {
  if (action === "confirm") {
    sitedData.value.page1_Step1 = 1;
    // 赋值置共享数据
    sitedData.value.order.groupTitle = data.value.groupInfo.title;
    sitedData.value.order.groupImg = data.value.groupInfo.img;
    // 置手机号输入框焦点
    document.getElementsByClassName("van-field__control")[1].focus();
  } else if (action === "cancel") {
    sitedData.value.page1_Step1 = 2;
  }
  data.value.isgroupInfoShow = false;
  return true;
};

// 监听课群内容是否发生改变 - > 恢复步骤一状态
watch(
  () => sitedData.value.groupID,
  () => {
    sitedData.value.page1_Step1 = 0;
    return true;
  }
);

// 忘记密码提示框
const forgetPassword = () => {
  Dialog.alert({
    confirmButtonText: "鸡倒了",
    title: "忘记易班密码咋办捏?",
    message:
      "易班账号为你的手机号\n密码一般是你自行设定的\n\n如果你忘记了密码\n可以打开易班通过手机号找回密码",
  });
};

// 提示错误填写
const onFailed = () => {
  Notify({ type: "danger", message: "请正确填写信息！" });
};

// 计算属性
const StepColor = (val) => {
  switch (val) {
    case 0:
      return { color: "#757575" };
    case 1:
      return { color: "green" };
    case 2:
      return { color: "red" };
    default:
      return { color: "#757575" };
  }
};
// 状态颜色
const page1_Step1Color = computed(() => {
  isPage1_Step1Disbale();
  return StepColor(sitedData.value.page1_Step1);
});
const page1_Step2Color = computed(() => {
  isPage1_Step1Disbale();
  return StepColor(sitedData.value.page1_Step2);
});

// 更新 下一步 按钮的禁止状态
const isPage1_Step1Disbale = () => {
  sitedData.value.page1_StepState =
    sitedData.value.page1_Step1 == 1 && sitedData.value.page1_Step2 == 1;
};

// 键盘回车事件 - > 查询课群信息
const queryGroupInfoKeyup = (e) => {
  if (e.keyCode == 13) {
    queryGroupInfo();
  }
};

// url取出参数
let paramsGroupid = router.currentRoute.value.query.groupID; // 课群ID
// 判断是否有邀请码
if (router.currentRoute.value.query.inviteCode) {
  // 写入浏览器缓存
  localStorage.setItem(
    "inviteCode",
    router.currentRoute.value.query.inviteCode
  );
}
if (!sitedData.value.showIntro) {
  // 查询课群信息
  if (paramsGroupid) {
    sitedData.value.groupID = paramsGroupid;
    queryGroupInfo();
  }
}

watch(
  () => sitedData.value.showIntro,
  (val) => {
    // 简介被关闭->读取课群信息
    if (!val && !sitedData.value.page1_Step1) {
      if (paramsGroupid) {
        sitedData.value.groupID = paramsGroupid;
        queryGroupInfo();
      }
    }
  }
);
</script>
<style scoped>
.notice-swipe {
  height: 40px;
  line-height: 40px;
}
.cover {
  width: 100%;
}
.NoticeBarClass {
  position: absolute;
  width: 100%;
  bottom: 10px;
}
.box {
  width: 100%;
  padding: 12px 0;
}

.box > h2,
.box > h5 {
  text-align: left;
  margin: 0;
  margin-left: 16px;
}

.box > h5 {
  margin-bottom: 10px;
  color: #757575;
}

.groupTitle {
  display: block;
  color: darkgoldenrod;
  padding-bottom: 10px;
}

.Step_help {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 16px;
  margin-bottom: 10px;
}
.vedioM {
  position: absolute;
  top: 20px;
  right: 70px;
  animation: scaleDraw 1s infinite;
}
@keyframes scaleDraw {
  0% {
    box-shadow: 0 0 0 0 rgba(31, 27, 27);
  }
  100% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }
}
</style>
<style>
.van-popover__wrapper {
  position: absolute;
  top: 16px;
  right: 20px;
  z-index: 999;
}
.inviteButton {
  position: absolute;
  top: 16px;
  right: 70px;
  font-weight: bold;
  z-index: 999;
  box-shadow: 0px 0px 5px 1px #ffef02;
}
</style>
